export const mutations = {
    setTransferenciaEstoque(state, data){
        state.transferenciaEstoque = data
    },
    setTransferenciasEstoques(state, data){
        state.transferenciasEstoques = data
    },
    addTransferenciaEstoque(state, data){
        state.transferencias.push(data)
    },
    removeTransferenciaEstoque(state, data){
        let index = state.transferencias.map(x => x.id).indexOf(data.id);
        state.transferencias.splice(index, 1)
    },
    setModalCadastroTransferenciaEstoque(state, status){
        state.modalCadastroTransferenciaEstoque = status
    },
    setModalVisualizarTransferenciaEstoque(state, status){
        state.modalVisualizarTransferenciaEstoque = status
    },
    setModalExcluirTransferenciaEstoque(state, status){
        state.modalExcluirTransferenciaEstoque = status
    },
    setItensTransferenciaEstoque(state, itens) {
        state.itensTransferenciaEstoque = itens
    }
}

export default {}